
import "./styles/PoleStatus.css"

const PoleStatus = ({ isOnline }) => {
  return (
    <div className={`pole-status ${isOnline ? "online" : "offline"}`}>
      <p>{isOnline ? "● เปิดใช้งาน" : "● ปิดใช้งาน"}</p>
    </div>
  );
};

export default PoleStatus;
